import { render } from "./SetPaymentTypeDialog.vue?vue&type=template&id=155b9dd9"
import script from "./SetPaymentTypeDialog.vue?vue&type=script&lang=js"
export * from "./SetPaymentTypeDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__